<template>
  <div class="w-100">
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="text-h6 text-center">
          {{ dialog_message }}
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="(dialog = false), (deldigit = false)"
          >
            ยกเลิก
          </v-btn>

          <v-btn
            color="red darken-1"
            text
            @click="(dialog = false), specialButtonDel()"
          >
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-if="selectedDigitType == 1" class="row-old-col">
      <button-item
        v-for="(item, index) in digits_any"
        :key="item.index"
        class="col-2"
        :class-button="getRateClass(digitType, item)"
        :key-value="item"
        :lotto-numbers-with-type="lottoNumbersWithType"
        :digit-type="digitType"
        @child-digitClick="digitClick"
      />
    </div>
    <div v-else-if="selectedDigitType == 2" class="row-old-col">
      <div class="col-12">
        <div class="row">
          <div class="col-4 px-1 mb-2">
            <button
              :class="{ active: nineTeenDigit }"
              class="w-100 btn btn-pink-custom px-0 py-3"
              @click="specialButtonGruop('nineteen')"
            >
              19 ประตู
            </button>
          </div>
          <div class="col-4 px-1 mb-2">
            <button
              :class="{ active: frontDigit }"
              class="w-100 btn btn-pink-custom px-0 py-3"
              @click="specialButtonGruop('front')"
            >
              รูดหน้า
            </button>
          </div>
          <div class="col-4 px-1 mb-2">
            <button
              :class="{ active: backDigit }"
              class="w-100 btn btn-pink-custom px-0 py-3"
              @click="specialButtonGruop('back')"
            >
              รูดหลัง
            </button>
          </div>
          <div class="col-4 px-1 mb-2">
            <button
              :class="{ active: evenNumberDigit }"
              class="w-100 btn btn-pink-custom px-0 py-3"
              @click="specialButtonGruop('evenNumber')"
            >
              คู่
            </button>
          </div>
          <div class="col-4 px-1 mb-2">
            <button
              :class="{ active: oddDigit }"
              class="w-100 btn btn-pink-custom px-0 py-3"
              @click="specialButtonGruop('odd')"
            >
              คี่
            </button>
          </div>
          <div class="col-4 px-1 mb-2">
            <button
              :class="{ active: highDigit }"
              class="w-100 btn btn-pink-custom px-0 py-3"
              @click="specialButtonGruop('high')"
            >
              สูง
            </button>
          </div>
          <div class="col-4 px-1 mb-2">
            <button
              :class="{ active: lowDigit }"
              class="w-100 btn btn-pink-custom px-0 py-3"
              @click="specialButtonGruop('low')"
            >
              ต่ำ
            </button>
          </div>
          <div class="col-4 px-1 mb-2">
            <button
              :class="{ active: doubleDigit }"
              class="w-100 btn btn-pink-custom px-0 py-3"
              @click="doubleButton"
            >
              เบิ้ล
            </button>
          </div>

          <div
            v-if="specialDigit && specialDigit != 'double'"
            class="col-12 my-3"
          >
            <div class="row">
              <div class="col-12 col-lg-6 px-0 mb-2 d-flex">
                <div
                  v-for="(item, digit, digitActive) in specialButtons"
                  v-if="digit < 5"
                  :key="item.digit + digit"
                  class="flex-width mx-1"
                >
                  <button
                    :data-buttonType="specialDigit"
                    :data-buttonDigit="item.digit"
                    :class="{ active: item.digitActive }"
                    class="btn w-100 btn-outline-pink mx-0 px-2 py-2"
                    @click="specialButtonClick"
                  >
                    {{ digit }}
                  </button>
                </div>
              </div>
              <div class="col-12 col-lg-6 px-0 mb-2 d-flex">
                <div
                  v-for="(item, digit, digitActive) in specialButtons"
                  v-if="digit >= 5"
                  :key="item.digit + digit"
                  class="flex-width mx-1"
                >
                  <button
                    :data-buttonType="specialDigit"
                    :data-buttonDigit="item.digit"
                    :class="{ active: item.digitActive }"
                    class="btn w-100 btn-outline-pink mx-0 px-2 py-2"
                    @click="specialButtonClick"
                  >
                    {{ digit }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-3">
        <div class="row-old-col">
          <div class="col-12 px-1 mb-2">
            <button
              :class="{ active: shuffleDigit }"
              class="w-100 btn btn-outline-dark py-3"
              @click="shuffleButton"
            >
              <i class="fas fa-random mr-2" /> สลับเลข
            </button>
          </div>
          <button-item
            v-for="(item, index) in digits_double"
            :key="item.index"
            class="col-2"
            :class-button="getRateClass(digitType, item)"
            :key-value="item"
            :lotto-numbers-with-type="lottoNumbersWithType"
            :digit-type="digitType"
            @child-digitClick="digitClick"
          />
        </div>
      </div>
    </div>
    <div v-else-if="selectedDigitType == 3" class="row-old-col">
      <div class="col-10 d-flex col-lg-5 px-0">
        <div
          v-for="(item, index) in button_triple_secments_1"
          :key="item.index"
          class="flex-width mb-3 mx-1"
        >
          <button
            :class="{ active: item.segment == selected }"
            class="btn btn-outline-yellow w-100"
            @click="pushButtonTriple(item.segment)"
          >
            {{ item.des }}
          </button>
        </div>
      </div>
      <div class="col-10 d-flex col-lg-5 px-0">
        <div
          v-for="(item, index) in button_triple_secments_2"
          :key="item.index"
          class="flex-width mb-3 mx-1"
        >
          <button
            :class="{ active: item.segment == selected }"
            class="btn btn-outline-yellow w-100"
            @click="pushButtonTriple(item.segment)"
          >
            {{ item.des }}
          </button>
        </div>
      </div>
      <div class="col-12 px-1 mb-2">
        <button
          :class="{ active: shuffleDigitTripple }"
          class="w-100 btn btn-outline-dark"
          @click="shuffleTripple"
        >
          <i class="fas fa-random mr-2" /> สลับเลข
        </button>
      </div>
      <button-item
        v-for="(item, index) in digits_triple"
        :key="item.index"
        class="col-2"
        :class-button="getRateClass(digitType, item)"
        :key-value="item"
        :lotto-numbers-with-type="lottoNumbersWithType"
        :digit-type="digitType"
        @child-digitClick="digitClick"
      />
    </div>
    <div v-else-if="selectedDigitType == 4" class="row-old-col">
      <div class="col-10 d-flex col-lg-5 px-0">
        <div
          v-for="(item, index) in button_triple_secments_1"
          :key="item.index"
          class="flex-width mb-3 mx-1"
        >
          <button
            :class="{ active: item.segment == selected }"
            class="btn btn-outline-yellow w-100"
            @click="pushButtonTriple(item.segment)"
          >
            {{ item.des }}
          </button>
        </div>
      </div>
      <div class="col-10 d-flex col-lg-5 px-0">
        <div
          v-for="(item, index) in button_triple_secments_2"
          :key="item.index"
          class="flex-width mb-3 mx-1"
        >
          <button
            :class="{ active: item.segment == selected }"
            class="btn btn-outline-yellow w-100"
            @click="pushButtonTriple(item.segment)"
          >
            {{ item.des }}
          </button>
        </div>
      </div>
      <div class="col-12 px-1 mb-2">
        <button
          :class="{ active: shuffleDigitTripple }"
          class="w-100 btn btn-outline-dark"
          @click="shuffleTripple"
        >
          <i class="fas fa-random mr-2" /> สลับเลข
        </button>
      </div>
      <button-item
        v-for="(item, index) in digits_triple"
        :key="item.index"
        class="col-2"
        :class-button="getRateClass(digitType, item)"
        :key-value="item"
        :lotto-numbers-with-type="lottoNumbersWithType"
        :digit-type="digitType"
        @child-digitClick="digitClick"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "BetButtonGroup",
  props: {
    digitType: {
      type: Array,
      required: true,
    },
    lottoNumbersWithType: {
      type: Array,
      required: true,
    },
    urlApiLottoRate: {
      type: String,
      default: "",
    },
    specialRate: {
      type: Array,
      required: true,
    },
    accepTants: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dialog_message: "",
      dialog: false,
      deldigit: false,
      delVal: "",
      digits_any: [],
      digits_double: [],
      digits_triple: [],
      selectedDigitType: 2,
      button_triple_secments_1: [
        {
          des: "000",
          segment: 0,
        },
        {
          des: "100",
          segment: 1,
        },
        {
          des: "200",
          segment: 2,
        },
        {
          des: "300",
          segment: 3,
        },
        {
          des: "400",
          segment: 4,
        },
      ],
      button_triple_secments_2: [
        {
          des: "500",
          segment: 5,
        },
        {
          des: "600",
          segment: 6,
        },
        {
          des: "700",
          segment: 7,
        },
        {
          des: "800",
          segment: 8,
        },
        {
          des: "900",
          segment: 9,
        },
      ],
      button_triple_loop_set: 0,
      selected: "",
      shuffleDigit: false,
      shuffleDigitTripple: false,
      nineTeenDigit: false,
      frontDigit: false,
      backDigit: false,
      evenNumberDigit: false,
      oddDigit: false,
      highDigit: false,
      lowDigit: false,
      doubleDigit: false,

      specialDigit: "",
      specialSelected: [],
      specialButtons: [
        {
          digit: 0,
          digitActive: false,
          currentType: "",
        },
        {
          digit: 1,
          digitActive: false,
          currentType: "",
        },
        {
          digit: 2,
          digitActive: false,
          currentType: "",
        },
        {
          digit: 3,
          digitActive: false,
          currentType: "",
        },
        {
          digit: 4,
          digitActive: false,
          currentType: "",
        },
        {
          digit: 5,
          digitActive: false,
          currentType: "",
        },
        {
          digit: 6,
          digitActive: false,
          currentType: "",
        },
        {
          digit: 7,
          digitActive: false,
          currentType: "",
        },
        {
          digit: 8,
          digitActive: false,
          currentType: "",
        },
        {
          digit: 9,
          digitActive: false,
          currentType: "",
        },
      ],

      nineteen_2under: [],
      nineteen_2upper: [],
      front_2under: [],
      front_2upper: [],
      back_2under: [],
      back_2upper: [],
      evenNumber_2under: [],
      evenNumber_2upper: [],
      odd_2under: [],
      odd_2upper: [],
      high_2under: [],
      high_2upper: [],
      low_2under: [],
      low_2upper: [],

      nineteenSpecial: [],
      frontSpecial: [],
      backSpecial: [],
      evenNumberSpecial: [],
      oddSpecial: [],
      highSpecial: [],
      lowSpecial: [],
    };
  },
  computed: {},
  watch: {
    digitType() {
      if (
        this.digitType.indexOf("any_upper") != -1 ||
        this.digitType.indexOf("any_under") != -1
      ) {
        this.selectedDigitType = 1;
      } else if (
        this.digitType.indexOf("2upper") != -1 ||
        this.digitType.indexOf("2under") != -1
      ) {
        this.selectedDigitType = 2;
        this.checkSpecialActiveGroup();
      } else if (
        this.digitType.indexOf("3upper") != -1 ||
        this.digitType.indexOf("3shuffle") != -1
      ) {
        this.selectedDigitType = 3;
      } else if (
        this.digitType.indexOf("3front") != -1 ||
        this.digitType.indexOf("3back") != -1
      ) {
        this.selectedDigitType = 4;
      } else {
        this.selectedDigitType = 0;
      }
    },
    lottoNumbersWithType() {
      if (this.lottoNumbersWithType.length == 0) {
        this.specialButtons = [
          {
            digit: 0,
            digitActive: false,
            currentType: "",
          },
          {
            digit: 1,
            digitActive: false,
            currentType: "",
          },
          {
            digit: 2,
            digitActive: false,
            currentType: "",
          },
          {
            digit: 3,
            digitActive: false,
            currentType: "",
          },
          {
            digit: 4,
            digitActive: false,
            currentType: "",
          },
          {
            digit: 5,
            digitActive: false,
            currentType: "",
          },
          {
            digit: 6,
            digitActive: false,
            currentType: "",
          },
          {
            digit: 7,
            digitActive: false,
            currentType: "",
          },
          {
            digit: 8,
            digitActive: false,
            currentType: "",
          },
          {
            digit: 9,
            digitActive: false,
            currentType: "",
          },
        ];
        this.nineteen_2under = [];
        this.nineteen_2upper = [];
        this.front_2under = [];
        this.front_2upper = [];
        this.back_2under = [];
        this.back_2upper = [];
        this.evenNumber_2under = [];
        this.evenNumber_2upper = [];
        this.odd_2under = [];
        this.odd_2upper = [];
        this.high_2under = [];
        this.high_2upper = [];
        this.low_2under = [];
        this.low_2upper = [];
        this.nineteenSpecial = [];
        this.frontSpecial = [];
        this.backSpecial = [];
        this.evenNumberSpecial = [];
        this.oddSpecial = [];
        this.highSpecial = [];
        this.lowSpecial = [];
      }
    },
    button_triple_loop_set() {
      this.digits_triple = [];
      for (
        let i = 0 + this.button_triple_loop_set * 100;
        i <= 99 + this.button_triple_loop_set * 100;
        i++
      ) {
        this.digits_triple.push(i);
      }
    },
  },
  mounted() {
    if (
      this.digitType.indexOf("any_upper") != -1 ||
      this.digitType.indexOf("any_under") != -1
    ) {
      this.selectedDigitType = 1;
    } else if (
      this.digitType.indexOf("2upper") != -1 ||
      this.digitType.indexOf("2under") != -1
    ) {
      this.selectedDigitType = 2;
    } else if (
      this.digitType.indexOf("3upper") != -1 ||
      this.digitType.indexOf("3shuffle") != -1
    ) {
      this.selectedDigitType = 3;
    } else if (
      this.digitType.indexOf("3back") != -1 ||
      this.digitType.indexOf("3front") != -1
    ) {
      this.selectedDigitType = 4;
    } else {
      this.selectedDigitType = 0;
    }
    for (var i = 0; i <= 9; i++) {
      this.digits_any.push(i);
    }
    for (var i = 0; i <= 99; i++) {
      this.digits_double.push(i);
    }
    for (
      var i = 0 + this.button_triple_loop_set * 100;
      i <= 99 + this.button_triple_loop_set * 100;
      i++
    ) {
      this.digits_triple.push(i);
    }
  },
  methods: {
    shuffleButton(evn) {
      this.shuffleDigit = !this.shuffleDigit;
      this.nineTeenDigit = false;
      this.frontDigit = false;
      this.backDigit = false;
      this.doubleDigit = false;
      this.evenNumberDigit = false;
      this.oddDigit = false;
      this.highDigit = false;
      this.lowDigit = false;
      this.specialDigit = false;
    },
    shuffleTripple(evn) {
      this.shuffleDigitTripple = !this.shuffleDigitTripple;
      this.specialDigit = false;
    },

    specialButtonGruop(data) {
      this.shuffleDigit = false;
      this.nineTeenDigit = false;
      this.frontDigit = false;
      this.backDigit = false;
      this.doubleDigit = false;
      this.evenNumberDigit = false;
      this.oddDigit = false;
      this.highDigit = false;
      this.lowDigit = false;
      switch (data) {
        case "nineteen":
          this.nineTeenDigit = !this.nineTeenDigit;
          break;
        case "front":
          this.frontDigit = !this.frontDigit;
          break;
        case "back":
          this.backDigit = !this.backDigit;
          break;
        case "evenNumber":
          this.evenNumberDigit = !this.evenNumberDigit;
          break;
        case "odd":
          this.oddDigit = !this.oddDigit;
          break;
        case "high":
          this.highDigit = !this.highDigit;
          break;
        case "low":
          this.lowDigit = !this.lowDigit;
          break;
        default:
      }
      this.$set(this, "specialDigit", data);
      this.checkSpecialActiveGroup();
    },
    doubleButton(evn) {
      this.shuffleDigit = false;
      this.nineTeenDigit = false;
      this.frontDigit = false;
      this.backDigit = false;
      this.doubleDigit = !this.doubleDigit;
      this.evenNumberDigit = false;
      this.oddDigit = false;
      this.highDigit = false;
      this.lowDigit = false;
      this.$set(this, "specialDigit", "double");
      let digitSearch;
      if (this.doubleDigit) {
        for (let i = 0; i < 10; i++) {
          if (i < 10) {
            if (i == 0) {
              digitSearch = "00";
            } else {
              digitSearch = i * 10 + i;
            }
            digitSearch = digitSearch.toString();
            const results = this.lottoNumbersWithType.filter(
              (l) => l.digits == digitSearch
            );
            if (results.length < 1) {
              this.digitClick(digitSearch);
            }
          }
        }
      } else {
        for (let i = 0; i < 10; i++) {
          if (i < 10) {
            if (i == 0) {
              digitSearch = "00";
            } else {
              digitSearch = i * 10 + i;
            }
            digitSearch = digitSearch.toString();
            const results = this.lottoNumbersWithType.filter(
              (l) => l.digits == digitSearch
            );
            if (results.length >= 1) {
              this.digitClick(digitSearch);
            }
          }
        }
      }
    },
    checkSpecialActiveGroup() {
      for (let i = 0; i < 10; i++) {
        this.checkSpecialActive(i);
      }
    },
    checkSpecialActive(val) {
      const index = this.specialButtons.findIndex((x) => x.digit == val);
      if (this.digitType.length == 2) {
        switch (this.specialDigit) {
          case "nineteen":
            if (
              this.nineteen_2under.indexOf(val) != -1 &&
              this.nineteen_2upper.indexOf(val) != -1
            ) {
              this.specialButtons[index].digitActive = true;
            } else {
              this.specialButtons[index].digitActive = false;
            }
            break;
          case "front":
            if (
              this.front_2under.indexOf(val) != -1 &&
              this.front_2upper.indexOf(val) != -1
            ) {
              this.specialButtons[index].digitActive = true;
            } else {
              this.specialButtons[index].digitActive = false;
            }
            break;
          case "back":
            if (
              this.back_2under.indexOf(val) != -1 &&
              this.back_2upper.indexOf(val) != -1
            ) {
              this.specialButtons[index].digitActive = true;
            } else {
              this.specialButtons[index].digitActive = false;
            }
            break;
          case "evenNumber":
            if (
              this.evenNumber_2under.indexOf(val) != -1 &&
              this.evenNumber_2upper.indexOf(val) != -1
            ) {
              this.specialButtons[index].digitActive = true;
            } else {
              this.specialButtons[index].digitActive = false;
            }
            break;
          case "odd":
            if (
              this.odd_2under.indexOf(val) != -1 &&
              this.odd_2upper.indexOf(val) != -1
            ) {
              this.specialButtons[index].digitActive = true;
            } else {
              this.specialButtons[index].digitActive = false;
            }
            break;
          case "high":
            if (
              this.high_2under.indexOf(val) != -1 &&
              this.high_2upper.indexOf(val) != -1
            ) {
              this.specialButtons[index].digitActive = true;
            } else {
              this.specialButtons[index].digitActive = false;
            }
            break;
          case "low":
            if (
              this.low_2under.indexOf(val) != -1 &&
              this.low_2upper.indexOf(val) != -1
            ) {
              this.specialButtons[index].digitActive = true;
            } else {
              this.specialButtons[index].digitActive = false;
            }
            break;
          default:
        }
      } else {
        switch (this.digitType[0]) {
          case "2under":
            switch (this.specialDigit) {
              case "nineteen":
                if (this.nineteen_2under.indexOf(val) != -1) {
                  this.specialButtons[index].digitActive = true;
                } else {
                  this.specialButtons[index].digitActive = false;
                }
                break;
              case "front":
                if (this.front_2under.indexOf(val) != -1) {
                  this.specialButtons[index].digitActive = true;
                } else {
                  this.specialButtons[index].digitActive = false;
                }
                break;
              case "back":
                if (this.back_2under.indexOf(val) != -1) {
                  this.specialButtons[index].digitActive = true;
                } else {
                  this.specialButtons[index].digitActive = false;
                }
                break;
              case "evenNumber":
                if (this.evenNumber_2under.indexOf(val) != -1) {
                  this.specialButtons[index].digitActive = true;
                } else {
                  this.specialButtons[index].digitActive = false;
                }
                break;
              case "odd":
                if (this.odd_2under.indexOf(val) != -1) {
                  this.specialButtons[index].digitActive = true;
                } else {
                  this.specialButtons[index].digitActive = false;
                }
                break;
              case "high":
                if (this.high_2under.indexOf(val) != -1) {
                  this.specialButtons[index].digitActive = true;
                } else {
                  this.specialButtons[index].digitActive = false;
                }
                break;
              case "low":
                if (this.low_2under.indexOf(val) != -1) {
                  this.specialButtons[index].digitActive = true;
                } else {
                  this.specialButtons[index].digitActive = false;
                }
                break;
              default:
            }
            break;
          case "2upper":
            switch (this.specialDigit) {
              case "nineteen":
                if (this.nineteen_2upper.indexOf(val) != -1) {
                  this.specialButtons[index].digitActive = true;
                } else {
                  this.specialButtons[index].digitActive = false;
                }
                break;
              case "front":
                if (this.front_2upper.indexOf(val) != -1) {
                  this.specialButtons[index].digitActive = true;
                } else {
                  this.specialButtons[index].digitActive = false;
                }
                break;
              case "back":
                if (this.back_2upper.indexOf(val) != -1) {
                  this.specialButtons[index].digitActive = true;
                } else {
                  this.specialButtons[index].digitActive = false;
                }
                break;
              case "evenNumber":
                if (this.evenNumber_2upper.indexOf(val) != -1) {
                  this.specialButtons[index].digitActive = true;
                } else {
                  this.specialButtons[index].digitActive = false;
                }
                break;
              case "odd":
                if (this.odd_2upper.indexOf(val) != -1) {
                  this.specialButtons[index].digitActive = true;
                } else {
                  this.specialButtons[index].digitActive = false;
                }
                break;
              case "high":
                if (this.high_2upper.indexOf(val) != -1) {
                  this.specialButtons[index].digitActive = true;
                } else {
                  this.specialButtons[index].digitActive = false;
                }
                break;
              case "low":
                if (this.low_2upper.indexOf(val) != -1) {
                  this.specialButtons[index].digitActive = true;
                } else {
                  this.specialButtons[index].digitActive = false;
                }
                break;
              default:
            }
            break;
          default:
        }
      }
    },
    specialButtonHandleDigit(digit) {
      self = this;
      const digitHandle = [];
      switch (this.specialDigit) {
        case "nineteen":
          for (let i = 0; i < 10; i++) {
            if (i < 10 && i != digit) {
              digitHandle.push(digit.toString() + i.toString());
            }
          }
          for (let i = 0; i < 10; i++) {
            if (i < 10) {
              digitHandle.push(i.toString() + digit.toString());
            }
          }
          break;
        case "front":
          for (let i = 0; i < 10; i++) {
            if (i < 10) {
              digitHandle.push(digit.toString() + i.toString());
            }
          }
          break;
        case "back":
          for (let i = 0; i < 10; i++) {
            if (i < 10) {
              digitHandle.push(i.toString() + digit.toString());
            }
          }
          break;
        case "evenNumber":
          for (let i = 0; i < 5; i++) {
            if (i < 5) {
              digitHandle.push(digit.toString() + i * 2);
            }
          }
          break;
        case "odd":
          for (let i = 0; i < 5; i++) {
            if (i < 5) {
              digitHandle.push(digit.toString() + (i * 2 + 1));
            }
          }
          break;
        case "high":
          for (let i = 5; i < 10; i++) {
            if (i < 10) {
              digitHandle.push(digit.toString() + i.toString());
            }
          }
          break;
        case "low":
          for (let i = 0; i < 5; i++) {
            if (i < 5) {
              digitHandle.push(digit.toString() + i.toString());
            }
          }
          break;
        default:
      }
      const index = this.specialButtons.findIndex((x) => x.digit == digit);
      if (this.specialButtons[index].digitActive) {
        digitHandle.map((value, key) => {
          self.digitType.map((valueType, key) => {
            const filters1 = self.lottoNumbersWithType.filter(
              (e) => e.digits == value.toString() && e.type == valueType
            );

            if (filters1 <= 0) {
              self.$emit(
                "child-digitClickSpecial",
                value.toString(),
                valueType,
                "push"
              );
            }
          });
        });
      } else {
        digitHandle.map((value, key) => {
          self.digitType.map((valueType, key) => {
            self.$emit(
              "child-digitClickSpecial",
              value.toString(),
              valueType,
              "splice"
            );
          });
        });
      }
    },
    specialButtonDel() {
      const val = this.delVal;
      this.$set(this, "deldigit", true);
      if (this.digitType.length == 2) {
        switch (this.specialDigit) {
          case "nineteen":
            if (this.deldigit == true) {
              this.$set(this, "deldigit", false);
              this.nineteen_2upper.splice(this.nineteen_2upper.indexOf(val), 1);
              this.nineteen_2under.splice(this.nineteen_2under.indexOf(val), 1);
            }
            break;
          case "front":
            if (this.deldigit == true) {
              this.$set(this, "deldigit", false);
              this.front_2upper.splice(this.front_2upper.indexOf(val), 1);
              this.front_2under.splice(this.front_2under.indexOf(val), 1);
            }
            break;
          case "back":
            if (this.deldigit == true) {
              this.back_2upper.splice(this.back_2upper.indexOf(val), 1);
              this.back_2under.splice(this.back_2under.indexOf(val), 1);
            }
            break;
          case "evenNumber":
            if (this.deldigit == true) {
              this.$set(this, "deldigit", false);
              this.evenNumber_2upper.splice(
                this.evenNumber_2upper.indexOf(val),
                1
              );
              this.evenNumber_2under.splice(
                this.evenNumber_2under.indexOf(val),
                1
              );
            }
            break;
          case "odd":
            if (this.deldigit == true) {
              this.$set(this, "deldigit", false);
              this.odd_2upper.splice(this.odd_2upper.indexOf(val), 1);
              this.odd_2under.splice(this.odd_2under.indexOf(val), 1);
            }
            break;
          case "high":
            if (this.deldigit == true) {
              this.$set(this, "deldigit", false);
              this.high_2upper.splice(this.high_2upper.indexOf(val), 1);
              this.high_2under.splice(this.high_2under.indexOf(val), 1);
            }
            break;
          case "low":
            if (this.deldigit == true) {
              this.$set(this, "deldigit", false);
              this.low_2upper.splice(this.low_2upper.indexOf(val), 1);
              this.low_2under.splice(this.low_2under.indexOf(val), 1);
            }
            break;
          default:
        }
      } else {
        switch (this.digitType[0]) {
          case "2under":
            switch (this.specialDigit) {
              case "nineteen":
                if (this.deldigit == true) {
                  this.$set(this, "deldigit", false);
                  this.nineteen_2under.splice(
                    this.nineteen_2under.indexOf(val),
                    1
                  );
                }
                break;
              case "front":
                if (this.deldigit == true) {
                  this.$set(this, "deldigit", false);
                  this.front_2under.splice(this.front_2under.indexOf(val), 1);
                }
                break;
              case "back":
                if (this.deldigit == true) {
                  this.$set(this, "deldigit", false);
                  this.back_2under.splice(this.back_2under.indexOf(val), 1);
                }
                break;
              case "evenNumber":
                if (this.deldigit == true) {
                  this.$set(this, "deldigit", false);
                  this.evenNumber_2under.splice(
                    this.evenNumber_2under.indexOf(val),
                    1
                  );
                }

                break;
              case "odd":
                if (this.deldigit == true) {
                  this.$set(this, "deldigit", false);
                  this.odd_2under.splice(this.odd_2under.indexOf(val), 1);
                }
                break;
              case "high":
                if (this.deldigit == true) {
                  this.$set(this, "deldigit", false);
                  this.high_2under.splice(this.high_2under.indexOf(val), 1);
                }
                break;
              case "low":
                if (this.deldigit == true) {
                  this.$set(this, "deldigit", false);
                  this.low_2under.splice(this.low_2under.indexOf(val), 1);
                }
                break;
              default:
            }
            break;
          case "2upper":
            switch (this.specialDigit) {
              case "nineteen":
                if (this.deldigit == true) {
                  this.$set(this, "deldigit", false);
                  this.nineteen_2upper.splice(
                    this.nineteen_2upper.indexOf(val),
                    1
                  );
                }
                break;
              case "front":
                if (this.deldigit == true) {
                  this.$set(this, "deldigit", false);
                  this.front_2upper.splice(this.front_2upper.indexOf(val), 1);
                }
                break;
              case "back":
                if (this.deldigit == true) {
                  this.$set(this, "deldigit", false);
                  this.back_2upper.splice(this.back_2upper.indexOf(val), 1);
                }
                break;
              case "evenNumber":
                if (this.deldigit == true) {
                  this.$set(this, "deldigit", false);
                  this.evenNumber_2upper.splice(
                    this.evenNumber_2upper.indexOf(val),
                    1
                  );
                }
                break;
              case "odd":
                if (this.deldigit == true) {
                  this.$set(this, "deldigit", false);
                  this.odd_2upper.splice(this.odd_2upper.indexOf(val), 1);
                }
                break;
              case "high":
                if (this.deldigit == true) {
                  this.$set(this, "deldigit", false);
                  this.high_2upper.splice(this.high_2upper.indexOf(val), 1);
                }
                break;
              case "low":
                if (this.deldigit == true) {
                  this.$set(this, "deldigit", false);
                  this.low_2upper.splice(this.low_2upper.indexOf(val), 1);
                }
                break;
              default:
            }
            break;
          default:
        }
      }
      this.checkSpecialActive(val);
      this.specialButtonHandleDigit(val);
    },
    specialButtonClick(eve) {
      const val = parseInt(eve.currentTarget.innerText);
      this.$set(this, "specialDigit", eve.target.dataset.buttontype);
      if (this.digitType.length == 2) {
        switch (eve.target.dataset.buttontype) {
          case "nineteen":
            if (
              this.nineteen_2upper.indexOf(val) != -1 &&
              this.nineteen_2under.indexOf(val) != -1
            ) {
              this.$set(this, "dialog", true);
              this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
              this.$set(this, "delVal", val);
            } else if (this.nineteen_2upper.indexOf(val) != -1) {
              this.nineteen_2under.push(val);
            } else if (this.nineteen_2under.indexOf(val) != -1) {
              this.nineteen_2upper.push(val);
            } else {
              this.nineteen_2upper.push(val);
              this.nineteen_2under.push(val);
            }
            break;
          case "front":
            if (
              this.front_2upper.indexOf(val) != -1 &&
              this.front_2under.indexOf(val) != -1
            ) {
              this.$set(this, "dialog", true);
              this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
              this.$set(this, "delVal", val);
            } else if (this.front_2upper.indexOf(val) != -1) {
              this.front_2under.push(val);
            } else if (this.front_2under.indexOf(val) != -1) {
              this.front_2upper.push(val);
            } else {
              this.front_2upper.push(val);
              this.front_2under.push(val);
            }
            break;
          case "back":
            if (
              this.back_2upper.indexOf(val) != -1 &&
              this.back_2under.indexOf(val) != -1
            ) {
              this.$set(this, "dialog", true);
              this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
              this.$set(this, "delVal", val);
            } else if (this.back_2upper.indexOf(val) != -1) {
              this.back_2under.push(val);
            } else if (this.back_2under.indexOf(val) != -1) {
              this.back_2upper.push(val);
            } else {
              this.back_2upper.push(val);
              this.back_2under.push(val);
            }
            break;
          case "evenNumber":
            if (
              this.evenNumber_2upper.indexOf(val) != -1 &&
              this.evenNumber_2under.indexOf(val) != -1
            ) {
              this.$set(this, "dialog", true);
              this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
              this.$set(this, "delVal", val);
            } else if (this.evenNumber_2upper.indexOf(val) != -1) {
              this.evenNumber_2under.push(val);
            } else if (this.evenNumber_2under.indexOf(val) != -1) {
              this.evenNumber_2upper.push(val);
            } else {
              this.evenNumber_2upper.push(val);
              this.evenNumber_2under.push(val);
            }
            break;
          case "odd":
            if (
              this.odd_2upper.indexOf(val) != -1 &&
              this.odd_2under.indexOf(val) != -1
            ) {
              this.$set(this, "dialog", true);
              this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
              this.$set(this, "delVal", val);
            } else if (this.odd_2upper.indexOf(val) != -1) {
              this.odd_2under.push(val);
            } else if (this.odd_2under.indexOf(val) != -1) {
              this.odd_2upper.push(val);
            } else {
              this.odd_2upper.push(val);
              this.odd_2under.push(val);
            }
            break;
          case "high":
            if (
              this.high_2upper.indexOf(val) != -1 &&
              this.high_2under.indexOf(val) != -1
            ) {
              this.$set(this, "dialog", true);
              this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
              this.$set(this, "delVal", val);
            } else if (this.high_2upper.indexOf(val) != -1) {
              this.high_2under.push(val);
            } else if (this.high_2under.indexOf(val) != -1) {
              this.high_2upper.push(val);
            } else {
              this.high_2upper.push(val);
              this.high_2under.push(val);
            }
            break;
          case "low":
            if (
              this.low_2upper.indexOf(val) != -1 &&
              this.low_2under.indexOf(val) != -1
            ) {
              this.$set(this, "dialog", true);
              this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
              this.$set(this, "delVal", val);
            } else if (this.low_2upper.indexOf(val) != -1) {
              this.low_2under.push(val);
            } else if (this.low_2under.indexOf(val) != -1) {
              this.low_2upper.push(val);
            } else {
              this.low_2upper.push(val);
              this.low_2under.push(val);
            }
            break;
          default:
        }
        this.checkSpecialActive(val);
        this.specialButtonHandleDigit(val);
      } else {
        switch (this.digitType[0]) {
          case "2under":
            switch (eve.target.dataset.buttontype) {
              case "nineteen":
                if (this.nineteen_2under.indexOf(val) != -1) {
                  this.$set(this, "dialog", true);
                  this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
                  this.$set(this, "delVal", val);
                } else {
                  this.nineteen_2under.push(val);
                }
                break;
              case "front":
                if (this.front_2under.indexOf(val) != -1) {
                  this.$set(this, "dialog", true);
                  this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
                  this.$set(this, "delVal", val);
                } else {
                  this.front_2under.push(val);
                }
                break;
              case "back":
                if (this.back_2under.indexOf(val) != -1) {
                  this.$set(this, "dialog", true);
                  this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
                  this.$set(this, "delVal", val);
                } else {
                  this.back_2under.push(val);
                }
                break;
              case "evenNumber":
                if (this.evenNumber_2under.indexOf(val) != -1) {
                  this.$set(this, "dialog", true);
                  this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
                  this.$set(this, "delVal", val);
                } else {
                  this.evenNumber_2under.push(val);
                }
                break;
              case "odd":
                if (this.odd_2under.indexOf(val) != -1) {
                  this.$set(this, "dialog", true);
                  this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
                  this.$set(this, "delVal", val);
                } else {
                  this.odd_2under.push(val);
                }
                break;
              case "high":
                if (this.high_2under.indexOf(val) != -1) {
                  this.$set(this, "dialog", true);
                  this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
                  this.$set(this, "delVal", val);
                } else {
                  this.high_2under.push(val);
                }
                break;
              case "low":
                if (this.low_2under.indexOf(val) != -1) {
                  this.$set(this, "dialog", true);
                  this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
                  this.$set(this, "delVal", val);
                } else {
                  this.low_2under.push(val);
                }
                break;
              default:
            }
            break;
          case "2upper":
            switch (eve.target.dataset.buttontype) {
              case "nineteen":
                if (this.nineteen_2upper.indexOf(val) != -1) {
                  this.$set(this, "dialog", true);
                  this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
                  this.$set(this, "delVal", val);
                } else {
                  this.nineteen_2upper.push(val);
                }
                break;
              case "front":
                if (this.front_2upper.indexOf(val) != -1) {
                  this.$set(this, "dialog", true);
                  this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
                  this.$set(this, "delVal", val);
                } else {
                  this.front_2upper.push(val);
                }
                break;
              case "back":
                if (this.back_2upper.indexOf(val) != -1) {
                  this.$set(this, "dialog", true);
                  this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
                  this.$set(this, "delVal", val);
                } else {
                  this.back_2upper.push(val);
                }
                break;
              case "evenNumber":
                if (this.evenNumber_2upper.indexOf(val) != -1) {
                  this.$set(this, "dialog", true);
                  this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
                  this.$set(this, "delVal", val);
                } else {
                  this.evenNumber_2upper.push(val);
                }
                break;
              case "odd":
                if (this.odd_2upper.indexOf(val) != -1) {
                  this.$set(this, "dialog", true);
                  this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
                  this.$set(this, "delVal", val);
                } else {
                  this.odd_2upper.push(val);
                }
                break;
              case "high":
                if (this.high_2upper.indexOf(val) != -1) {
                  this.$set(this, "dialog", true);
                  this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
                  this.$set(this, "delVal", val);
                } else {
                  this.high_2upper.push(val);
                }
                break;
              case "low":
                if (this.low_2upper.indexOf(val) != -1) {
                  this.$set(this, "dialog", true);
                  this.$set(this, "dialog_message", `ต้องการลบเลข ${val}`);
                  this.$set(this, "delVal", val);
                } else {
                  this.low_2upper.push(val);
                }
                break;
              default:
            }
            break;
          default:
        }
        this.checkSpecialActive(val);
        this.specialButtonHandleDigit(val);
      }
    },
    ShuffleDouble(val) {
      let valset;
      valset = val.toString();
      valset = valset.split("");
      valset = valset.reverse();
      valset = valset.join("");
      if (valset == val) {
        return false;
      }
      return valset.toString();
    },

    removeAllElements(array, elem) {
      let index = array.indexOf(elem);
      while (index > -1) {
        array.splice(index, 1);
        index = array.indexOf(elem);
      }
    },

    digitClick(val) {
      this.$emit("child-digitClick", val);
      if (this.selectedDigitType == 2 && this.shuffleDigit) {
        this.$emit("child-digitShuffleClick", this.ShuffleDouble(val));
      }
      if (this.selectedDigitType == 3 && this.shuffleDigitTripple) {
        let valset = "";
        valset = val.toString();
        valset = valset.split("");
        let valtemp = "";
        if (valset[0] == valset[1] && valset[1] == valset[2]) {
        } else if (valset[0] == valset[1]) {
          for (let i = 1; i < 3; i++) {
            switch (i) {
              case 1:
                valtemp = valset[0] + valset[2] + valset[1];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              case 2:
                valtemp = valset[2] + valset[1] + valset[0];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              default:
            }
          }
        } else if (valset[0] == valset[2]) {
          for (let i = 1; i < 3; i++) {
            switch (i) {
              case 1:
                valtemp = valset[0] + valset[2] + valset[1];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              case 2:
                valtemp = valset[1] + valset[0] + valset[2];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              default:
            }
          }
        } else if (valset[1] == valset[2]) {
          for (let i = 1; i < 3; i++) {
            switch (i) {
              case 1:
                valtemp = valset[2] + valset[1] + valset[0];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              case 2:
                valtemp = valset[1] + valset[0] + valset[2];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              default:
            }
          }
        } else {
          for (let i = 1; i <= 5; i++) {
            switch (i) {
              case 1:
                valtemp = valset[0] + valset[2] + valset[1];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              case 2:
                valtemp = valset[1] + valset[0] + valset[2];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              case 3:
                valtemp = valset[1] + valset[2] + valset[0];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              case 4:
                valtemp = valset[2] + valset[0] + valset[1];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              case 5:
                valtemp = valset[2] + valset[1] + valset[0];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              default:
            }
          }
        }
      }
      if (this.selectedDigitType == 4 && this.shuffleDigitTripple) {
        let valset = "";
        valset = val.toString();
        valset = valset.split("");
        let valtemp = "";
        if (valset[0] == valset[1] && valset[1] == valset[2]) {
          // this.$emit("child-digitShuffleClick", val);
        } else if (valset[0] == valset[1]) {
          for (let i = 1; i < 3; i++) {
            switch (i) {
              case 1:
                valtemp = valset[0] + valset[2] + valset[1];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              case 2:
                valtemp = valset[2] + valset[1] + valset[0];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              default:
            }
          }
        } else if (valset[0] == valset[2]) {
          for (let i = 1; i < 3; i++) {
            switch (i) {
              case 1:
                valtemp = valset[0] + valset[2] + valset[1];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              case 2:
                valtemp = valset[1] + valset[0] + valset[2];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              default:
            }
          }
        } else if (valset[1] == valset[2]) {
          for (let i = 1; i < 3; i++) {
            switch (i) {
              case 1:
                valtemp = valset[2] + valset[1] + valset[0];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              case 2:
                valtemp = valset[1] + valset[0] + valset[2];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              default:
            }
          }
        } else {
          for (let i = 1; i <= 5; i++) {
            switch (i) {
              case 1:
                valtemp = valset[0] + valset[2] + valset[1];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              case 2:
                valtemp = valset[1] + valset[0] + valset[2];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              case 3:
                valtemp = valset[1] + valset[2] + valset[0];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              case 4:
                valtemp = valset[2] + valset[0] + valset[1];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              case 5:
                valtemp = valset[2] + valset[1] + valset[0];
                valtemp = valtemp.toString();
                this.$emit("child-digitShuffleClick", valtemp);
                break;
              default:
            }
          }
        }
      }
    },
    pushButtonTriple(val) {
      this.selected = val;
      this.button_triple_loop_set = val;
    },
    getRateClass(type, digit) {
      let results;

      if (type.length == 2) {
        const results1 = this.specialRate.filter(
          (i) => i.digit == digit && i.type == type[0]
        );
        const results2 = this.specialRate.filter(
          (i) => i.digit == digit && i.type == type[1]
        );

        if (results1.length > 0 && results2.length > 0) {
          if (results1[0].pay_percent > results2[0].pay_percent) {
            results = this.specialRate.filter(
              (i) => i.digit == digit && i.type == type[0]
            );
          }
          if (results2[0].pay_percent > results1[0].pay_percent) {
            results = this.specialRate.filter(
              (i) => i.digit == digit && i.type == type[1]
            );
          }
          if (results1[0].pay_percent == results2[0].pay_percent) {
            results = this.specialRate.filter(
              (i) => i.digit == digit && i.type == type[0]
            );
          }
        } else if (results1.length > 0) {
          results = this.specialRate.filter(
            (i) => i.digit == digit && i.type == type[0]
          );
        } else {
          results = this.specialRate.filter(
            (i) => i.digit == digit && i.type == type[1]
          );
        }
      } else {
        results = this.specialRate.filter(
          (i) => i.digit == digit && i.type == type[0]
        );
      }
      if (results.length > 0) {
        const bonusRate = this.specialRate.filter(
          (i) =>
            i.digit == digit && i.pay_percent > 100 && i.pay_type == "special"
        );

        if (bonusRate.length > 0) {
          return "btn text-monospace w-100 btn-danger";
        }

        if (results.length == 1) {
          if (bonusRate.length > 0) {
            return "btn text-monospace w-100 btn-danger";
          }
          if (results[0].pay_percent < 12) {
            if (results[0].pay_type != "special") {
              return "btn text-monospace w-100 btn-outline-bet-navy";
            }
            return "btn text-monospace w-100 btn-outline-bet-purple";
          }
          if (results[0].pay_percent == 12 || results[0].pay_percent == 12.5) {
            if (results[0].pay_type != "special") {
              return "btn text-monospace w-100 btn-outline-bet-blue";
            }
            return "btn text-monospace w-100 btn-outline-bet-purple";
          }
          if (results[0].pay_percent == 20 || results[0].pay_percent == 25) {
            if (results[0].pay_type != "special") {
              return "btn text-monospace w-100 btn-outline-bet-red";
            }
            return "btn text-monospace w-100 btn-outline-bet-purple";
          }
          if (results[0].pay_percent == 50) {
            if (results[0].pay_type != "special") {
              return "btn text-monospace w-100 btn-outline-bet-orange";
            }
            return "btn text-monospace w-100 btn-outline-bet-purple";
          }
          if (results[0].pay_percent == 75) {
            if (results[0].pay_type != "special") {
              return "btn text-monospace w-100 btn-outline-bet-yellow";
            }
            return "btn text-monospace w-100 btn-outline-bet-purple";
          }
        } else if (results[0].pay_percent <= results[1].pay_percent) {
          if (bonusRate.length > 0) {
            return "btn text-monospace w-100 btn-danger";
          }
          if (results[0].pay_percent < 12) {
            if (results[0].pay_type != "special") {
              return "btn text-monospace w-100 btn-outline-bet-navy";
            }
            return "btn text-monospace w-100 btn-outline-bet-purple";
          }
          if (results[0].pay_percent == 12 || results[0].pay_percent == 12.5) {
            if (results[0].pay_type != "special") {
              return "btn text-monospace w-100 btn-outline-bet-blue";
            }
            return "btn text-monospace w-100 btn-outline-bet-purple";
          }
          if (results[0].pay_percent == 20 || results[0].pay_percent == 25) {
            if (results[0].pay_type != "special") {
              return "btn text-monospace w-100 btn-outline-bet-red";
            }
            return "btn text-monospace w-100 btn-outline-bet-purple";
          }
          if (results[0].pay_percent == 50) {
            if (results[0].pay_type != "special") {
              return "btn text-monospace w-100 btn-outline-bet-orange";
            }
            return "btn text-monospace w-100 btn-outline-bet-purple";
          }
          if (results[0].pay_percent == 75) {
            if (results[0].pay_type != "special") {
              return "btn text-monospace w-100 btn-outline-bet-yellow";
            }
            return "btn text-monospace w-100 btn-outline-bet-purple";
          }
        } else {
          if (bonusRate.length > 0) {
            return "btn text-monospace w-100 btn-danger";
          }
          if (results[1].pay_percent < 12) {
            if (results[1].pay_type != "special") {
              return "btn text-monospace w-100 btn-outline-bet-navy";
            }
            return "btn text-monospace w-100 btn-outline-bet-purple";
          }
          if (results[1].pay_percent == 12 || results[1].pay_percent == 12.5) {
            if (results[1].pay_type != "special") {
              return "btn text-monospace w-100 btn-outline-bet-blue";
            }
            return "btn text-monospace w-100 btn-outline-bet-purple";
          }
          if (results[1].pay_percent == 20 || results[1].pay_percent == 25) {
            if (results[1].pay_type != "special") {
              return "btn text-monospace w-100 btn-outline-bet-red";
            }
            return "btn text-monospace w-100 btn-outline-bet-purple";
          }
          if (results[1].pay_percent == 50) {
            if (results[1].pay_type != "special") {
              return "btn text-monospace w-100 btn-outline-bet-orange";
            }
            return "btn text-monospace w-100 btn-outline-bet-purple";
          }
          if (results[1].pay_percent == 75) {
            if (results[1].pay_type != "special") {
              return "btn text-monospace w-100 btn-outline-bet-yellow";
            }
            return "btn text-monospace w-100 btn-outline-bet-purple";
          }
        }
      } else {
        return "btn text-monospace w-100 btn-outline-dark";
      }
    },
  },
};
</script>
